import { ReactElement } from 'react';
import CollapsibleSection from '../CollapsibleSection';
import { Typography } from '@weareopenr/component-library';
import styles from 'src/components/PriceRuleFlowShared/PriceRule.module.scss';

type Section = {
  title: string;
  subtitle: string;
  children?: ReactElement;
};

type Props = {
  name: string;
  sections: Section[];
};

const PriceRuleOverview = ({ name, sections }: Props) => {
  return (
    <>
      <Typography className={styles['title']} size="xxlarge" weight="semi-bold">
        Summary for <b>{name}</b>
      </Typography>
      <div className={styles['collapsible-container']}>
        {sections.map(({ title, subtitle, children }, i) => (
          <CollapsibleSection key={title} number={String(i + 1)} title={title} subtitle={subtitle}>
            {children}
          </CollapsibleSection>
        ))}
      </div>
    </>
  );
};

export default PriceRuleOverview;
